import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask, round2Decimals } from "../../Components/Items";
import numeroALetra from "../../Components/numeroALetra";
import { pdfStylesV2, divisorV2, PDF_COLORS, PDF_PAGE_MARGINS, pdfFz, applyPdfColors } from "../../Components/PdfComponents/componentsv2.0/stylesPDFv2";
import { PDFHeaderV2 } from "../../Components/PdfComponents/componentsv2.0/PDFHeader";
import { PDFClientInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFClientInfo";
import { PDFItemsTableV2, PDFItemImagesV2 } from "../../Components/PdfComponents/componentsv2.0/PDFItemsTable";
import { PDFSummarySectionV2 } from "../../Components/PdfComponents/componentsv2.0/PDFTotalsSummary";
import { PDFPaymentInfoV2 } from "../../Components/PdfComponents/componentsv2.0/PDFPaymentInfo";
import { PDFNotesV2 } from "../../Components/PdfComponents/componentsv2.0/PDFNotes";
import { PDFBrandFooterConNumeroV2 } from "../../Components/PdfComponents/componentsv2.0/PDFFooter";
import { formatearDireccionEntrega } from "../../Components/PdfComponents/formatearDireccionEntrega";
import { BloqueFirmasPdf } from "../../Components/PdfComponents/BloqueFirmasPdf";
import { normalizarFilaTabla } from "../../Components/PdfComponents/normalizarFilaTabla";
// Registra la tipografía Mulish en pdfMake (efecto secundario) y expone su nombre.
import MULISH_FONT from "./mulishFont";
// Registra la variante Mulish SemiBold (600) usada en las etiquetas (efecto secundario).
import "./mulishSemiBoldFont";

moment.locale("es");


const cotizacionPdfV2 = (values) => {
  const empresa = values.respuestaFactura.empresa;
  const logoBiwo = values.logoBiwo?.base64Completa || values.respuestaFactura?.logoBiwo?.base64Completa;

  applyPdfColors(empresa);

  const quitarImpuestosRemisiones = empresa?.quitarImpuestosRemisiones || values.quitarImpuestos || false;
  const ocultarColumnaIVA = empresa?.ocultarColumnaIVA || false;
  const cantidadJuntoPrecioUnitario = empresa?.cantidadJuntoPrecioUnitario || false;
  const dataSat = values.respuestaFactura.dataSat;
  const direccionEntrega = values.respuestaFactura?.dataSat?.direccionEntrega || null;
  const mostrarDescUnidad = empresa?.imprimirDesUnidad;
  const mostrarRegimen = !empresa?.deshabilitarRegimenFiscal;
  const mostrarTipoComprobante = !empresa?.deshabilitarTipoComprobantePdf;
  const mostrarMoneda = !empresa?.deshabilitarMonedaPdf;
  const mostrarLugarExpedicion = !empresa?.deshabilitarLugarExpedicionPdf;
  const mostrarCondicionesPago = !empresa?.deshabilitarCondicionesPagoPdf;
  const mostrarMetodoPago = !empresa?.deshabilitarMetodoPagoPdf;
  const mostrarOC = !empresa?.deshabilitarOCPdf;
  const mostrarFecha = !empresa?.deshabilitarFechaPdf;
  const mostrarFechaEntrega = !empresa?.deshabilitarFechaEntregaPdf;
  const ocultarColumnaPU = !!empresa?.ocultarColumnaPU;
  const ocultarColumnaImporte = !!empresa?.ocultarColumnaImporte;
  const mostrarCuadroTotales = !empresa?.ocultarCuadroTotalesPdf;
  // Columna con el P/U ya descontado, a la derecha del P/U
  const precioUnitarioConDescuento = empresa?.precioUnitarioConDescuento === true && !ocultarColumnaPU;
  const widthPUConDescuento = 9;
  const { referencia: referenciaEntrega, direccion: direccionEntregaTexto } = formatearDireccionEntrega(
    direccionEntrega,
    { mostrarReferencia: !!empresa?.mostrarReferenciaEntregaPdf }
  );
  // Texto, no arreglo: kvRows esparce cualquier objeto como nodo y con [] la celda queda sin
  // `text` (pdfmake: "Unrecognized document structure"). Las respuestas de agregarVenta,
  // generarFactura, etc. no traen `proyecto`; solo obtenerRespuestaFactura lo arma.
  const proyecto = values.respuestaFactura?.dataSat?.proyecto || "";
  const decimalesPrecioUnitarioPdf = Number.isFinite(Number(empresa?.decimalesPrecioUnitarioPdf)) ? Number(empresa.decimalesPrecioUnitarioPdf) : 2;
  const decimalesCantidadPdf = Number.isFinite(Number(empresa?.decimalesCantidadPdf)) ? Number(empresa.decimalesCantidadPdf) : 2;
  const formatCantidad = (val) => {
    const num = Number(val);
    if (!Number.isFinite(num)) return val;
    return num.toLocaleString('es-MX', { minimumFractionDigits: decimalesCantidadPdf, maximumFractionDigits: decimalesCantidadPdf });
  };

  let agregarImpDesc = 0;
  // Mas abajo se hace `{ ...paq }`, y en Mongoose 5 el spread de un subdocumento
  // NO copia los campos del esquema (son getters del prototipo): quedaria
  // nombre/_id en undefined. Los caminos del frontend se salvan porque res.json()
  // ya paso por toJSON(), pero los del backend (correo, WhatsApp) reciben el
  // documento vivo, asi que hay que aplanarlo aqui.
  const paquetes = (dataSat?.paquetes || []).map((paq) =>
    paq && typeof paq.toObject === "function" ? paq.toObject() : paq
  );
  const esDataUrlValida = (s) =>
    typeof s === "string" &&
    /^data:(image|application)\/[a-zA-Z0-9.+-]+;base64,/.test(s);

  const mostrarClaveSAT = !empresa?.deshabilitarClaveSATCot;
  const mostrarClave = !empresa?.deshabilitarClaveCot;

  const widthClaveSAT = quitarImpuestosRemisiones ? 8 : 9;
  const widthClave = quitarImpuestosRemisiones ? 9 : 12;
  const widthIEPS = 8;
  const widthIVA = 8;
  const widthPU = quitarImpuestosRemisiones ? 15 : 10.5;
  const widthImporte = quitarImpuestosRemisiones ? 15 : 12.5;

  let widthExtraDescripcion = 0;
  if (!mostrarClaveSAT) widthExtraDescripcion += widthClaveSAT;
  if (!mostrarClave) widthExtraDescripcion += widthClave;
  if (!quitarImpuestosRemisiones && !empresa.imprimirIEPS) {
    widthExtraDescripcion += widthIEPS;
  }
  if (!quitarImpuestosRemisiones && ocultarColumnaIVA) {
    widthExtraDescripcion += widthIVA;
  }
  if (ocultarColumnaPU) widthExtraDescripcion += widthPU;
  if (ocultarColumnaImporte) widthExtraDescripcion += widthImporte;

  const widthExtraCantidad = Math.round(widthExtraDescripcion * 0.05 * 10) / 10;
  const widthExtraUnidad = Math.round(widthExtraDescripcion * 0.15 * 10) / 10;
  const widthExtraClave = mostrarClave ? Math.round(widthExtraDescripcion * 0.15 * 10) / 10 : 0;
  const widthExtraDescripcionFinal = Math.round((widthExtraDescripcion - widthExtraCantidad - widthExtraUnidad - widthExtraClave) * 10) / 10;

  const mapaIndicesPaquete = {};
  const totalesPorPaquete = {};

  paquetes.forEach((paq) => {
    totalesPorPaquete[paq._id] = { importe: 0, iva: 0, ieps: 0, descuento: 0, total: 0 };

    paq.insumos.forEach((insumoRef, i) => {
      const idx = insumoRef.indice;
      const esInicio = i === 0;
      const esFin = i === paq.insumos.length - 1;
      mapaIndicesPaquete[idx] = { ...paq, esInicio, esFin };
    });
  });

  dataSat.Conceptos.forEach((concepto, index) => {
    const infoPaquete = mapaIndicesPaquete[index];
    if (infoPaquete) {
      const idRef = infoPaquete._id;
      let ivaItem = 0;
      let iepsItem = 0;
      concepto.Impuestos?.Traslados?.forEach((imp) => {
        if (imp.Impuesto === "002") ivaItem += (imp.Importe || 0);
        if (imp.Impuesto === "003") iepsItem += (imp.Importe || 0);
      });
      const importeItem = Number(concepto.Importe || 0);
      const descItem = Number(concepto.Descuento || 0);
      totalesPorPaquete[idRef].importe += importeItem;
      totalesPorPaquete[idRef].iva += ivaItem;
      totalesPorPaquete[idRef].ieps += iepsItem;
      totalesPorPaquete[idRef].descuento += descItem;
      totalesPorPaquete[idRef].total += (importeItem - descItem + ivaItem + iepsItem);
    }
  });

  // Construcción de conceptos con posible fila de imágenes
  const conceptos = dataSat.Conceptos.flatMap((valueConcepto, index) => {
    let iva = 0;
    let ieps = 0;
    let agregarImpConcepto = 0;
    const relacionDescuento = Number(valueConcepto.Descuento || 0) / Number(valueConcepto.Importe || 1);

    valueConcepto.Impuestos?.Traslados?.forEach((valueImpuesto) => {
      if (valueImpuesto.Impuesto === "002" && valueImpuesto.Importe) {
        iva += valueImpuesto.Importe;
        agregarImpConcepto += valueImpuesto.Importe / (1 - relacionDescuento) - valueImpuesto.Importe;
      }
      if (valueImpuesto.Impuesto === "003" && valueImpuesto.Importe) {
        ieps += valueImpuesto.Importe;
        agregarImpConcepto += valueImpuesto.Importe / (1 - relacionDescuento) - valueImpuesto.Importe;
      }
    });

    agregarImpDesc += agregarImpConcepto;

    const infoPaquete = mapaIndicesPaquete[index];
    const perteneceAPaquete = !!infoPaquete;
    const mostrarPrecios = perteneceAPaquete ? infoPaquete.imprimirDesglose : true;

    const prevInfo = mapaIndicesPaquete[index - 1];
    const paqueteAcabaDeTerminar = prevInfo && (!infoPaquete || String(infoPaquete._id) !== String(prevInfo._id));

    const filasResultado = [];
    let calculoColumnas = 6;
    if (mostrarClaveSAT) calculoColumnas++;
    if (mostrarClave) calculoColumnas++;
    if (!quitarImpuestosRemisiones) {
      if (!ocultarColumnaIVA) calculoColumnas++;
      if (empresa.imprimirIEPS) calculoColumnas++;
    }
    if (ocultarColumnaPU) calculoColumnas--;
    if (ocultarColumnaImporte) calculoColumnas--;
    if (precioUnitarioConDescuento) calculoColumnas++;
    const totalCols = calculoColumnas;

    // Separador visual entre paquetes
    if (paqueteAcabaDeTerminar) {
      filasResultado.push([
        { colSpan: totalCols, text: '', border: [false, false, false, false], fillColor: '#ffffff', fontSize: pdfFz(5), lineHeight: 0.5 },
        ...Array.from({ length: totalCols - 1 }, () => ({})),
      ]);
    }

    // Fila si es paquete
    if (infoPaquete && infoPaquete.esInicio) {
      const totalesPaq = totalesPorPaquete[infoPaquete._id];
      const cantidadPaquetes = infoPaquete.cantidad || 1;
      // Con la columna de IVA oculta la fila del paquete tiene que cuadrar contra la suma de sus
      // renglones, que se imprimen netos: subtotal menos descuentos, sin IVA ni IEPS.
      const totalPaquete = ocultarColumnaIVA ? totalesPaq.importe - totalesPaq.descuento : totalesPaq.total;
      const importeUnitarioPaquete = totalPaquete / cantidadPaquetes;

      const colorFondoPaquete = PDF_COLORS.tint;
      const estiloTextoPaquete = { bold: true, fontSize: pdfFz(6), color: PDF_COLORS.ink };

      const celdaCantidadPaquete = { text: cantidadPaquetes, style: "textoTablaChico", alignment: "right", fillColor: colorFondoPaquete, ...estiloTextoPaquete };
      const filaHeaderPaquete = [
        { text: '', fillColor: colorFondoPaquete, border: [true, true, false, true] },
        ...(cantidadJuntoPrecioUnitario ? [] : [celdaCantidadPaquete]),
        { text: mostrarDescUnidad ? 'Paquete' : 'PQT', style: "textoTablaChico", alignment: "center", fillColor: colorFondoPaquete, ...estiloTextoPaquete },
        ...(mostrarClaveSAT ? [{ text: '', fillColor: colorFondoPaquete }] : []),
        ...(mostrarClave ? [{ text: '', fillColor: colorFondoPaquete }] : []),
        { text: `${infoPaquete.nombre}`, style: "textoTablaChico", alignment: "left", fillColor: colorFondoPaquete, ...estiloTextoPaquete, fontSize: pdfFz(6) },
        ...(cantidadJuntoPrecioUnitario ? [celdaCantidadPaquete] : []),
        ...(ocultarColumnaPU ? [] : [{ text: dineroDisabledMask(quitarImpuestosRemisiones ? totalesPaq.importe / cantidadPaquetes : importeUnitarioPaquete, decimalesPrecioUnitarioPdf), style: "textoTablaChico", alignment: "right", fillColor: colorFondoPaquete, ...estiloTextoPaquete }]),
        // P/U c/Desc. del paquete (el P/U del paquete ya viene neto salvo sin desglose de impuestos)
        ...(precioUnitarioConDescuento ? [{ text: dineroDisabledMask(quitarImpuestosRemisiones ? (totalesPaq.importe - totalesPaq.descuento) / cantidadPaquetes : importeUnitarioPaquete, decimalesPrecioUnitarioPdf), style: "textoTablaChico", alignment: "right", fillColor: colorFondoPaquete, ...estiloTextoPaquete }] : []),
        ...(quitarImpuestosRemisiones ? [] : [
          ...(ocultarColumnaIVA ? [] : [{ text: dineroDisabledMask(totalesPaq.iva), style: "textoTablaChico", fillColor: colorFondoPaquete, alignment: "right" }]),
          ...(empresa.imprimirIEPS ? [{ text: dineroDisabledMask(totalesPaq.ieps), style: "textoTablaChico", fillColor: colorFondoPaquete, alignment: "right" }] : []),
        ]),
        ...(ocultarColumnaImporte ? [] : [{ text: dineroDisabledMask(quitarImpuestosRemisiones ? totalesPaq.importe : totalPaquete), style: "textoTablaChico", alignment: "right", fillColor: colorFondoPaquete, ...estiloTextoPaquete, border: [false, true, true, true] }]),
      ];
      filasResultado.push(normalizarFilaTabla(filaHeaderPaquete, totalCols));
    }

    // Fila para insumo normal
    const textoPrecioUnitario = mostrarPrecios
      ? dineroDisabledMask(quitarImpuestosRemisiones
        ? (Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto) / Number(valueConcepto.Cantidad || 1)
        : valueConcepto.ValorUnitario, decimalesPrecioUnitarioPdf)
      : "";
    // P/U menos el descuento del renglón, en la misma base que la columna P/U
    const textoPrecioUnitarioNeto = mostrarPrecios
      ? dineroDisabledMask(quitarImpuestosRemisiones
        ? (Number(valueConcepto.Importe) - Number(valueConcepto.Descuento || 0) + iva + ieps) / Number(valueConcepto.Cantidad || 1)
        : Number(valueConcepto.ValorUnitario) - Number(valueConcepto.Descuento || 0) / Number(valueConcepto.Cantidad || 1), decimalesPrecioUnitarioPdf)
      : "";
    const textoImporte = mostrarPrecios
      ? dineroDisabledMask(quitarImpuestosRemisiones
        ? Number(valueConcepto.Importe) + iva + ieps + agregarImpConcepto
        : valueConcepto.Importe)
      : "";

    const textoIVA = mostrarPrecios ? dineroDisabledMask(iva) : "";
    const textoIEPS = mostrarPrecios ? dineroDisabledMask(ieps) : "";
    const paddingNombre = perteneceAPaquete ? "      • " : "";
    const colorFondoItem = perteneceAPaquete ? "#f7fcff" : null;
    const colorTextoItem = perteneceAPaquete ? PDF_COLORS.muted : PDF_COLORS.ink;

    const imagenesEntrada = Array.isArray(valueConcepto.imagenes) ? valueConcepto.imagenes : [];
    const imagenesBase64 = imagenesEntrada
      .map((img) => (typeof img === "string" ? img : img?.base64Completa))
      .filter(esDataUrlValida);

    const celdaCantidadFila = { style: "textoTablaChico", text: formatCantidad(valueConcepto.Cantidad), alignment: "right", fillColor: colorFondoItem, color: colorTextoItem };
    const filaBase = [
      { style: "textoTablaChico", text: index + 1, alignment: "center", fillColor: colorFondoItem },
      ...(cantidadJuntoPrecioUnitario ? [] : [celdaCantidadFila]),
      {
        text: (() => {
          const textoUnidad = (mostrarDescUnidad && valueConcepto.descUnidad) ? valueConcepto.descUnidad : valueConcepto.ClaveUnidad;
          return valueConcepto.presentacionCliente || textoUnidad;
        })(),
        style: "textoTablaChico", alignment: "center", fillColor: colorFondoItem, color: colorTextoItem
      },
      ...(mostrarClaveSAT ? [{ text: valueConcepto.ClaveProdServ, style: "textoTablaChico", alignment: "center", fillColor: colorFondoItem, color: colorTextoItem }] : []),
      ...(mostrarClave ? [{ text: valueConcepto.NoIdentificacion, style: "textoTablaChico", alignment: "center", fillColor: colorFondoItem, color: colorTextoItem }] : []),
      (() => {
        const textoDescSinObs =
          paddingNombre + valueConcepto.Descripcion +
          (valueConcepto?.CuentaPredial?.[0]?.Numero ? ("\nPredial: " + valueConcepto?.CuentaPredial?.[0]?.Numero) : "") +
          (valueConcepto.Marca ? "\nMarca: " + valueConcepto.Marca : "") +
          (valueConcepto.CodigoBarras ? "\n" + valueConcepto.CodigoBarras : "");
        const textoDesc = textoDescSinObs + (valueConcepto.Observaciones ? "\n" + valueConcepto.Observaciones : "");
        const extras = [];
        if (Array.isArray(valueConcepto.Lotes) && valueConcepto.Lotes.length > 0) {
          extras.push({ text: valueConcepto.Lotes.map(lote => `Cant: ${lote?.cantidadRequerida ?? "-"} - Lote: ${lote?.numero ?? lote?.lote ?? "-"} - Cad: ${lote?.caducidad && moment(lote.caducidad).isSameOrAfter(moment(dataSat.Fecha), 'day') ? moment(lote.caducidad).format("DD/MM/YYYY") : "-"}`).join("\n"), fontSize: pdfFz(5), color: "#555", margin: [0, 2, 0, 0] });
        }
        const imgsNode = PDFItemImagesV2(imagenesBase64);
        if (imgsNode) extras.push(imgsNode);
        if (valueConcepto.DescripcionLarga) {
          // Descripcion larga del producto (solo PDF): debajo del concepto y antes de las observaciones
          return {
            stack: [
              { text: textoDescSinObs, style: "textoTablaChico", color: colorTextoItem },
              { text: valueConcepto.DescripcionLarga, fontSize: pdfFz(5), color: "#555", margin: [0, 1, 0, 0] },
              ...(valueConcepto.Observaciones ? [{ text: valueConcepto.Observaciones, style: "textoTablaChico", color: colorTextoItem }] : []),
              ...extras,
            ],
            alignment: "left",
            fillColor: colorFondoItem,
          };
        }
        if (extras.length) {
          return { stack: [{ text: textoDesc, style: "textoTablaChico" }, ...extras], alignment: "left", fillColor: colorFondoItem };
        }
        return { text: textoDesc, style: "textoTablaChico", alignment: "left", fillColor: colorFondoItem, color: colorTextoItem };
      })(),
      ...(cantidadJuntoPrecioUnitario ? [celdaCantidadFila] : []),
      ...(ocultarColumnaPU ? [] : [{
        stack: [
          { text: textoPrecioUnitario, style: "textoTablaChico", alignment: "right", color: colorTextoItem },
          ...(
            mostrarPrecios && !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
              ? [{
                columns: [
                  { text: round2Decimals((Number(valueConcepto.Descuento) * 100) / (Number(valueConcepto.Cantidad || 1) * Number(valueConcepto.ValorUnitario || 1))) + "%:", width: "*", alignment: "left", style: "descuentoPartida", noWrap: true },
                  { text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento / (Number(valueConcepto.Cantidad || 1)))), width: "auto", alignment: "right", style: "descuentoPartida", noWrap: true },
                ],
                columnGap: 8, margin: [0, 2, 0, 0],
              }]
              : []
          )
        ],
        fillColor: colorFondoItem,
      }]),
      ...(precioUnitarioConDescuento ? [{ text: textoPrecioUnitarioNeto, style: "textoTablaChico", alignment: "right", color: colorTextoItem, fillColor: colorFondoItem }] : []),
      ...(quitarImpuestosRemisiones ? [] : [
        ...(ocultarColumnaIVA ? [] : [{ text: textoIVA, style: "textoTablaChico", alignment: "right", fillColor: colorFondoItem, color: colorTextoItem }]),
        ...(empresa.imprimirIEPS ? [{ text: textoIEPS, style: "textoTablaChico", alignment: "right", fillColor: colorFondoItem, color: colorTextoItem }] : []),
      ]),
      ...(ocultarColumnaImporte ? [] : [{
        stack: [
          { text: textoImporte, style: "textoTablaChico", alignment: "right", color: colorTextoItem },
          ...(
            mostrarPrecios && !isNaN(valueConcepto.Descuento) && Number(valueConcepto.Descuento) > 0
              ? [{ text: "- " + dineroDisabledMask(Number(valueConcepto.Descuento)), style: "descuentoPartida", alignment: "right", margin: [0, 2, 0, 0] }]
              : []
          )
        ],
        fillColor: colorFondoItem,
      }])
    ];

    filasResultado.push(filaBase);
    return filasResultado;
  });

  const nuevoArrayImpFL = Array.isArray(dataSat.Impuestos.Traslados)
    ? [...dataSat.Impuestos.Traslados, ...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["implocal:TrasladosLocales"] || [])]
    : [...(dataSat?.Complemento?.Any?.[0]?.["implocal:ImpuestosLocales"]?.["implocal:TrasladosLocales"] || [])];

  let totalImpuestos = 0;

  const ordenImpuestos = ["IVA 0%", "IVA 16%", "IEPS 6%", "IEPS 7%", "IEPS 9%"];

  const nuevoArrayImpFLOdenado = [...nuevoArrayImpFL].sort((a, b) => {
    const nombreA = a.Impuesto === "002" ? `IVA ${round2Decimals(a.TasaOCuota * 100)}%` : a.Impuesto === "003" ? `IEPS ${round2Decimals(a.TasaOCuota * 100)}%` : a["@ImpLocTrasladado"];
    const nombreB = b.Impuesto === "002" ? `IVA ${round2Decimals(b.TasaOCuota * 100)}%` : b.Impuesto === "003" ? `IEPS ${round2Decimals(b.TasaOCuota * 100)}%` : b["@ImpLocTrasladado"];
    return ordenImpuestos.indexOf(nombreA) - ordenImpuestos.indexOf(nombreB);
  });

  const impuestosTotales = nuevoArrayImpFLOdenado.map((valueImpuesto) => {
    let nombre = "";
    if (valueImpuesto.Impuesto === "002") nombre = "IVA";
    else if (valueImpuesto.Impuesto === "003") nombre = "IEPS";
    else nombre = valueImpuesto["@ImpLocTrasladado"];
    if (valueImpuesto.TipoFactor === "Tasa") nombre = nombre + " " + round2Decimals(valueImpuesto.TasaOCuota * 100) + "%";
    else if (valueImpuesto.TipoFactor === "Cuota") nombre = nombre + " $" + round2Decimals(valueImpuesto.TasaOCuota);
    totalImpuestos += valueImpuesto.Importe || valueImpuesto["@Importe"];
    return { label: nombre, value: dineroDisabledMask(valueImpuesto.Importe || valueImpuesto["@Importe"] || 0) };
  });

  const nuevoArrayRetFL = Array.isArray(dataSat.Impuestos.Retenciones)
    ? [...dataSat.Impuestos.Retenciones, ...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"]["implocal:RetencionesLocales"] || [])]
    : [...(dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"]["implocal:RetencionesLocales"] || [])];

  const retencionesTotales = nuevoArrayRetFL.map((valueRetencion) => {
    let nombre = "Retención ";
    if (valueRetencion.Impuesto === "001") nombre = nombre + "ISR";
    else if (valueRetencion.Impuesto === "002") nombre = nombre + "IVA";
    else nombre = valueRetencion["@ImpLocRetenido"];
    return { label: nombre, value: dineroDisabledMask(valueRetencion.Importe || valueRetencion["@Importe"]) };
  });

  const totalImpFL =
    dataSat.Impuestos.TotalImpuestosTrasladados +
    (dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"]["@TotaldeTraslados"] || 0) || 0;
  const totalRetFL =
    dataSat.Impuestos.TotalImpuestosRetenidos +
    (dataSat?.Complemento?.Any[0]["implocal:ImpuestosLocales"]["@TotaldeRetenciones"] || 0) || 0;

  let cancelado = {};
  if (values.estado === 0) {
    cancelado = { watermark: { text: "CANCELADO", color: "GRAY", opacity: 0.3, bold: true, italics: false, angle: -50, fontSize: 110 } };
  } else if (values.esPreview) {
    cancelado = { watermark: { text: 'VISTA PREVIA', color: '#1677ff', opacity: 0.15, bold: true, italics: false, angle: -50, fontSize: 90 } };
  }

  const mostrarBancos = !dataSat?.deshabilitarBanco;
  const filasBanco1 = [
    { label: "Banco:", value: empresa.banco ? empresa.banco : "" },
    ...(empresa.swiftCode ? [{ label: "Swift Code:", value: empresa.swiftCode ? empresa.swiftCode : "" }] : []),
    ...(empresa.abaCode ? [{ label: "ABA Code:", value: empresa.abaCode ? empresa.abaCode : "" }] : []),
    { label: "Cuenta:", value: empresa.cuentaBanco ? empresa.cuentaBanco : "" },
    { label: "Cuenta CLABE:", value: empresa.cuentaClabe ? empresa.cuentaClabe : "" },
  ];

  const total = dataSat.SubTotal - dataSat.Descuento + totalImpFL;

  const vendedorVar = empresa.vendedorVentas && values.vendedor ? values.vendedor : null;

  // --- Tabla de conceptos: encabezado + anchos (mismos del clásico) ---
  const title = [
    { text: "", style: "tituloTabla" },
    ...(cantidadJuntoPrecioUnitario ? [] : [{ text: "Cant", style: "tituloTabla" }]),
    { text: "Unidad", style: "tituloTabla" },
    ...(mostrarClaveSAT ? [{ text: "Clave SAT", style: "tituloTabla" }] : []),
    ...(mostrarClave ? [{ text: "Clave", style: "tituloTabla" }] : []),
    { text: "Descripción", style: "tituloTabla" },
    ...(cantidadJuntoPrecioUnitario ? [{ text: "Cant", style: "tituloTabla" }] : []),
    ...(ocultarColumnaPU ? [] : [{ text: "P/U", style: "tituloTabla" }]),
    ...(precioUnitarioConDescuento ? [{ text: "P/U c/Desc.", style: "tituloTabla" }] : []),
    ...(quitarImpuestosRemisiones ? [] : [
      ...(ocultarColumnaIVA ? [] : [{ text: "IVA", style: "tituloTabla" }]),
      ...(empresa.imprimirIEPS ? [{ text: "IEPS", style: "tituloTabla" }] : []),
    ]),
    ...(ocultarColumnaImporte ? [] : [{ text: "Importe", style: "tituloTabla" }]),
  ];

  const widths = quitarImpuestosRemisiones
    ? [
      "2%",
      ...(cantidadJuntoPrecioUnitario ? [] : [`${7 + widthExtraCantidad}%`]),
      `${8 + widthExtraUnidad}%`,
      ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),
      ...(mostrarClave ? [`${widthClave + widthExtraClave}%`] : []),
      `${36 + widthExtraDescripcionFinal - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,
      ...(cantidadJuntoPrecioUnitario ? [`${7 + widthExtraCantidad}%`] : []),
      ...(ocultarColumnaPU ? [] : ["15%"]),
      ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []),
      ...(ocultarColumnaImporte ? [] : ["15%"]),
    ]
    : [
      "2%",
      ...(cantidadJuntoPrecioUnitario ? [] : [`${4 + widthExtraCantidad}%`]),
      `${6 + widthExtraUnidad}%`,
      ...(mostrarClaveSAT ? [`${widthClaveSAT}%`] : []),
      ...(mostrarClave ? [`${widthClave + widthExtraClave}%`] : []),
      `${28 + widthExtraDescripcionFinal - (precioUnitarioConDescuento ? widthPUConDescuento : 0)}%`,
      ...(cantidadJuntoPrecioUnitario ? [`${4 + widthExtraCantidad}%`] : []),
      ...(ocultarColumnaPU ? [] : ["10.5%"]),
      ...(precioUnitarioConDescuento ? [`${widthPUConDescuento}%`] : []),
      ...(ocultarColumnaIVA ? [] : ["8%"]),
      ...(empresa.imprimirIEPS ? [`${widthIEPS}%`] : []),
      ...(ocultarColumnaImporte ? [] : ["12.5%"]),
    ];

  // --- Metadata del encabezado (columna derecha) ---
  const headerMeta = [
    { label: "N° Cotización:", value: (dataSat.Serie ? dataSat.Serie : "C") + " - " + dataSat.Folio },
    ...(mostrarMoneda ? [{ label: "Moneda:", value: dataSat.Moneda }] : []),
    ...(mostrarLugarExpedicion ? [{ label: "Lugar de expedición:", value: dataSat.LugarExpedicion }] : []),
    { label: "Fecha de vencimiento:", value: moment(dataSat.fechaVigencia).locale("es").format("LL") },
    ...(dataSat.pedido && mostrarOC ? [{ label: "Orden de compra:", value: dataSat.pedido }] : []),
    ...(dataSat.req ? [{ label: "Req:", value: dataSat.req }] : []),
    ...(mostrarCondicionesPago ? [{
      label: "Condiciones de pago:",
      value: dataSat.condicion === 1 ? "Contado" : "Crédito (" + (dataSat?.Receptor?.diasCredito ? dataSat?.Receptor?.diasCredito : "0") + " días)",
    }] : []),
    ...(vendedorVar ? [{ label: "Vendedor:", value: vendedorVar.nombre + (vendedorVar.apellidoPaterno ? " " + vendedorVar.apellidoPaterno : "") + (vendedorVar.apellidoMaterno ? " " + vendedorVar.apellidoMaterno : "") }] : []),
  ];

  // --- Datos cliente / proyecto ---
  const clienteLeft = [
    { label: "Nombre del cliente:", value: dataSat.Receptor.leyenda ? dataSat.Receptor.leyenda : dataSat.Receptor.Nombre, strong: true },
    ...(dataSat?.Receptor?.codigoProveedor ? [{ label: "Código Proveedor:", value: dataSat.Receptor.codigoProveedor }] : []),
    ...(mostrarFecha ? [{ label: "Fecha:", value: moment(dataSat.Fecha).locale("es").format("LL") }] : []),
    ...(mostrarMetodoPago ? [{ label: "Método de pago:", value: dataSat.MetodoPago === "PUE" ? "PUE - Pago en una sola exhibición" : "PPD - Pago en parcialidades o diferido" }] : []),
  ];

  const clienteRight = [
    ...(empresa?.mostrarProyectoVentas ? [{ label: "Proyecto:", value: proyecto, strong: true }] : []),
    ...(referenciaEntrega ? [{ label: "Referencia:", value: referenciaEntrega }] : []),
    ...(direccionEntrega?.destino ? [{ label: "Destino:", value: direccionEntrega?.destino }] : []),
    ...(direccionEntrega?.embarque ? [{ label: "Embarque:", value: direccionEntrega?.embarque }] : []),
    ...(direccionEntregaTexto ? [{ label: "Dirección de Entrega:", value: direccionEntregaTexto }] : []),
    ...(mostrarFechaEntrega && dataSat.fechaEntregaEstimada ? [{ label: "Fecha de entrega estimada:", value: moment(dataSat.fechaEntregaEstimada).locale("es").format("LL") }] : []),
    ...(dataSat?.atencion ? [{ label: "Atención a:", value: dataSat.atencion }] : []),
  ];

  // --- Cierre: importe con letra + datos bancarios (izquierda) ---
  const bancosRows = mostrarBancos ? [...filasBanco1] : [];
  const importeLetra = {
    text: [
      { text: "Importe con letra:  ", style: "subheader" },
      { text: "( " + numeroALetra(dataSat.Total, dataSat.Moneda) + " )", style: "textoChico" },
    ],
    margin: [0, 0, 0, 8],
  };
  const cierreIzquierda = {
    stack: [
      ...(mostrarCuadroTotales ? [importeLetra] : []),
      ...(bancosRows.length ? [PDFPaymentInfoV2({ titulo: "Datos bancarios", rows: bancosRows })] : []),
    ],
  };

  // --- Filas de totales (derecha) ---
  const totalsRows = [
    {
      label: "Subtotal:",
      value: dineroDisabledMask(quitarImpuestosRemisiones ? dataSat.SubTotal + totalImpuestos + agregarImpDesc : dataSat.SubTotal),
    },
    ...(((quitarImpuestosRemisiones ? dataSat.Descuento + agregarImpDesc : dataSat.Descuento) > 0)
      ? [{
        label: "Descuento:",
        value: "- " + dineroDisabledMask(quitarImpuestosRemisiones ? dataSat.Descuento + agregarImpDesc : dataSat.Descuento),
      }]
      : []),
    ...(quitarImpuestosRemisiones ? [] : impuestosTotales),
    { label: "TOTAL:", value: dineroDisabledMask(total), strong: true },
    ...retencionesTotales,
    ...(totalRetFL > 0 ? [{ label: "TOTAL PAGO:", value: dineroDisabledMask(dataSat.Total), strong: true }] : []),
  ];

  const dd = {
    ...cancelado,
    info: {
      title: (dataSat.Serie ? dataSat.Serie : "C") + " - " + dataSat.Folio + " ( " + dataSat.Receptor.Rfc + " - " + dataSat.Receptor.Nombre + " )",
      author: "BIWO ERP",
      subject: "Cotización",
      creator: "pdfmake",
    },
    content: [
      PDFHeaderV2({
        empresa,
        tituloPrincipal: "Cotización",
        tituloFolio: "N° " + (dataSat.Serie ? dataSat.Serie : "C") + " - " + dataSat.Folio,
        regimenFiscal: mostrarRegimen,
        tipoComprobante: mostrarTipoComprobante ? "ingreso" : false,
        meta: headerMeta,
      }),
      PDFClientInfoV2({ left: clienteLeft, right: clienteRight }),
      divisorV2(PDF_COLORS.neutralDivider, 6, 1),
      PDFItemsTableV2({ title, conceptos, widths }),
      PDFSummarySectionV2({ left: cierreIzquierda, rows: mostrarCuadroTotales ? totalsRows : [] }),
      PDFNotesV2(values.imprimirObservaciones && values.observaciones ? values.observaciones : null),
      ...(empresa.textoAdicionalPedidosCotizaciones
        ? [
          divisorV2(PDF_COLORS.neutralDivider, 6, 1),
          { text: empresa.textoAdicionalPedidosCotizaciones, style: "textoAdicionalPedidosCotizaciones", margin: [0, 2, 0, 0] },
        ]
        : []),
      ...(empresa?.camposFirmaVentas ? [BloqueFirmasPdf([{ titulo: "Entregó" }, { titulo: "Recibió" }])] : []),
    ],
    footer: PDFBrandFooterConNumeroV2(logoBiwo),
    images: {
      logo: empresa.logo.base64Completa,
    },
    styles: pdfStylesV2(empresa),
    defaultStyle: { font: MULISH_FONT },
    pageSize: "LETTER",
    pageMargins: PDF_PAGE_MARGINS,
  };

  return dd;
};

export default cotizacionPdfV2;
